import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
} from '@angular/router';
import { tap } from 'rxjs/operators';
import { PermissionsService } from '../user';

@Injectable({ providedIn: 'root' })
export class PermissionsGuard implements CanActivate, CanActivateChild {
  constructor(
    private _permissions: PermissionsService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const CodPermiso = +route.data.CodPermiso;
    const redirectTo = route.data.redirectTo || '/acceso-denegado';
    return this._checkPermission(CodPermiso, redirectTo);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot) {
    const CodPermisoParent = +childRoute.parent.data.CodPermiso;
    const redirectTo = childRoute.data.redirectTo || '/acceso-denegado';
    return this._checkPermission(CodPermisoParent, redirectTo);
  }

  private _checkPermission(CodPermiso: number, redirectTo: string) {
    return this._permissions.checkPermission(CodPermiso).pipe(
      tap((hasAuthorization) => {
        if (!hasAuthorization) {
          this.router.navigate([redirectTo]);
        }
      })
    );
  }
}
